import SEO from "@/components/site/SEO";
import Hero from "@/components/site/Hero";
import ServicesGrid from "@/components/site/ServicesGrid";
import WhyChooseUs from "@/components/site/WhyChooseUs";
import FAQSection from "@/components/site/FAQSection";
import QuoteCTA from "@/components/site/QuoteCTA";

export default function Home() {
  return (
    <div data-testid="home-page">
      <SEO
        title="Parking Lot Striping & Sealcoating — Memphis & Mid-South"
        description="901 Lots stripes, seals, and maintains parking lots for businesses across Memphis and the Mid-South. ADA compliance, restriping, and pavement marking. Free quotes."
        path="/"
      />
      <Hero />
      <ServicesGrid compact />
      <WhyChooseUs />
      {/* FAQ section is visual-only here — full FAQPage schema lives on /faq
          to avoid duplicate-content markup across the site. */}
      <FAQSection
        title="Common questions"
        eyebrow="FAQ"
        subtitle="The questions we hear most often from Mid-South property owners. See the full list on our FAQ page."
        limit={6}
        showSeeAllLink
        background="slate"
      />
      <QuoteCTA />
    </div>
  );
}
